import React from 'react';
import { Box } from '@mui/material';

const SectionDivider = () => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      my: { xs: 3, md: 5 }
    }}
  >
    <Box
      sx={{
        width: { xs: '60%', md: '30%' },
        borderBottom: '2.5px solid #722F37',
        borderRadius: 2,
        opacity: 0.7
      }}
    />
  </Box>
);

export default SectionDivider; 